
<div class="audit-step__badge" [class.audit-step__badge--checked]="badgeStatus()"><i class="gw-pen audit-step-badge__icon--current"></i><i class="gw-check audit-step-badge__icon--check"></i><span class="audit-step-badge__index">{{ id + 1 }}</span></div>
<div class="audit-step__heading" (click)="goTo()" [class.audit-step__heading--link]="allowedToGoToStep()">
  <div class="audit-step-heading__name">{{ title }}</div>
  <div class="audit-step-heading__subheading">{{ heading }}</div>
</div>